import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5l0 14","key":"svg-0"}],["path",{"d":"M12 5l0 14","key":"svg-1"}],["path",{"d":"M16 5l0 14","key":"svg-2"}]]

const IconTallymark3 = createReactComponent('outline', 'tallymark-3', 'Tallymark3', __iconNode);

export default IconTallymark3;